import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useParams } from 'react-router-dom';

import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const getData = async (callback) => {
  const { response: user } = (await StorageHandler.load(storageKeys.user)) || {};
  let response = await StorageHandler.load(storageKeys.favorites);

  if (response === false && user) {
    response = await APIHandler.getFavorite(DataHandler.matchAppIdSync(), user.email);
    StorageHandler.save(storageKeys.favorites, response);
  }

  if (user) {
    callback({
      user,
      favorites: response,
    });
  }
};

const AddFavorite = ({ avoidVideoControls, bgEnabled, centered, color, upID, viewType }) => {
  const { chapterId } = useParams();

  const [toggled, setToggled] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    getData(({ user: newUser, favorites: newFavorites }) => {
      setUser(newUser);

      const value = newFavorites.data.find(
        ({ unid, type }) =>
          unid.toString() === upID.toString().slice((viewType === 'p' && chapterId?.length) || 0) && type === viewType,
      );

      setToggled(value !== undefined);
    });
  }, [upID, viewType, chapterId?.length]);

  const updateFavorites = async (newToggled) => {
    const allFavorites = await StorageHandler.load(storageKeys.favorites);
    const params = {
      app_id: DataHandler.matchAppIdSync(),
      type: viewType,
      unid: upID.toString().slice((viewType === 'p' && chapterId?.length) || 0),
      email: user.email,
    };

    const { response, data } = await APIHandler[newToggled ? 'addFavorite' : 'removeFavorite'](params);
    if (response === undefined) {
      let newFavorites = [...allFavorites.data];
      if (data === undefined) {
        newFavorites.splice(
          newFavorites.findIndex(({ unid, type }) => unid.toString() === upID.toString() && type === viewType),
          1,
        );
      } else newFavorites = [...allFavorites.data, data];

      StorageHandler.save(storageKeys.favorites, {
        data: newFavorites,
      });
    }

    // Status 422 means the item was already favorited
    // This indicates a synchronisation error and attempt to fix
    if (response?.status === 422 && user) {
      StorageHandler.save(
        storageKeys.favorites,
        await APIHandler.getFavorite(DataHandler.matchAppIdSync(), user.email),
      );
    }
  };

  const toggleHandler = ({ type, key }) => {
    if (type === 'click' || (type === 'keydown' && key === 'Enter')) {
      updateFavorites(!toggled);
      setToggled(!toggled);
    }
  };

  return (
    user && (
      <div className={clsx('addFavorite__container', { centered, avoidVideoControls })}>
        <div
          className={clsx('addFavorite__background', { bgEnabled, colored: color })}
          onClick={toggleHandler}
          onKeyDown={toggleHandler}
          role="button"
          tabIndex={0}
        >
          <FontAwesomeIcon icon={[toggled ? 'fas' : 'far', 'heart']} />
        </div>
      </div>
    )
  );
};

export default AddFavorite;

AddFavorite.propTypes = {
  viewType: PropTypes.string.isRequired,
  upID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  bgEnabled: PropTypes.bool,
  centered: PropTypes.bool,
  avoidVideoControls: PropTypes.bool,
  color: PropTypes.bool,
};

AddFavorite.defaultProps = {
  bgEnabled: false,
  centered: false,
  avoidVideoControls: false,
  color: false,
};
